import type { Pas, Tranche } from '@iobiz/shared'

/**
 * Les LIBELLÉS des tranches d'un graphe — partagés par le tableau de bord et
 * la fenêtre de graphe, pour qu'une même colonne porte partout le même nom.
 */

/** Une date civile, interprétée en UTC pour ne pas glisser d'un jour. */
const enDate = (civile: string): Date => {
  const [a, m, j] = civile.split('-').map(Number) as [number, number, number]
  return new Date(Date.UTC(a, m - 1, j || 1))
}

export function libellesDe(
  decoupage: readonly Tranche[],
  pas: Pas,
): { courts: string[]; longs: string[] } {
  const utc = { timeZone: 'UTC' } as const
  if (pas === 'jour') {
    return {
      courts: decoupage.map((t) => `${t.cle.slice(8, 10)}/${t.cle.slice(5, 7)}`),
      longs: decoupage.map((t) =>
        new Intl.DateTimeFormat('fr-FR', {
          ...utc,
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric',
        }).format(enDate(t.du)),
      ),
    }
  }
  if (pas === 'mois') {
    const court = new Intl.DateTimeFormat('fr-FR', { ...utc, month: 'short' })
    return {
      // L'année s'ajoute en janvier et à la première colonne : sans elle, douze
      // mois glissants ne disent pas où l'on change d'année.
      courts: decoupage.map((t, i) => {
        const mois = court.format(enDate(t.du))
        return i === 0 || t.cle.endsWith('-01') ? `${mois} ${t.cle.slice(2, 4)}` : mois
      }),
      longs: decoupage.map((t) =>
        new Intl.DateTimeFormat('fr-FR', { ...utc, month: 'long', year: 'numeric' }).format(
          enDate(t.du),
        ),
      ),
    }
  }
  return {
    courts: decoupage.map((t) => t.cle),
    longs: decoupage.map((t) => `Année ${t.cle}`),
  }
}

export const compact = new Intl.NumberFormat('fr-FR', {
  notation: 'compact',
  maximumFractionDigits: 1,
})
